import script from "./ClientBill.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientBill.vue?vue&type=script&setup=true&lang=js"

import "./ClientBill.vue?vue&type=style&index=0&id=38179b06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38179b06"]])

export default __exports__